/**
 * PDP accordions - header first, panel second; toggle .active on .accordion-item
 */
(function () {
  'use strict';

  function setItemOpen(item, open) {
    var btn = item.querySelector('.accordion-header');
    var panel = item.querySelector('.accordion-content');
    if (!btn || !panel) return;

    item.classList.toggle('active', open);
    item.classList.toggle('is-open', open);
    btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    panel.setAttribute('aria-hidden', open ? 'false' : 'true');
  }

  document.querySelectorAll('[data-pdp-desc-panel] .accordion-header').forEach(function (button) {
    button.addEventListener('click', function () {
      var item = button.closest('.accordion-item');
      if (!item) return;

      var willOpen = !item.classList.contains('active');

      if (willOpen) {
        var scope =
          item.closest('[data-pdp-accordion-scope]') ||
          item.closest('.accordion') ||
          item.closest('.pdp-product-description-section') ||
          document.documentElement;
        scope.querySelectorAll('.accordion-item.active').forEach(function (other) {
          if (other !== item) {
            setItemOpen(other, false);
          }
        });
      }

      setItemOpen(item, willOpen);
    });
  });
})();
